angular.module('impactx.numberingscheme').controller('NumberingSchemeListCtrl', [
    'selectedListItems',
    NumberingSchemeListCtrl
]);

function NumberingSchemeListCtrl(selectedListItems) {
    var buttonDefinition = [
        {
            label: "details",
            linkFunction: getDetailLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'NumberingScheme'
        }
    ];

    this.meta = {
        buttonDefinition: buttonDefinition,
        rowTemplate: 'modules/numberingscheme/templates/numberingschemelist.row.tmpl.html',
        isSelectAble: true,
        endpoint: '/numberingscheme/list',
        ctrl: this,
        id: "numberingschemelist",
        mainAction : {id:"new", link: "#/numberingscheme/0", icon:"mdi-plus"},
        excelExport: true
    };

    this.getMeta = function() {
        return this.meta;
    };

    function getDetailLink() {
        return "numberingscheme/" + selectedListItems.getFirstSelectedId();
    }
}